import { render, staticRenderFns } from "./deduction-record.vue?vue&type=template&id=b4b3ab6e&scoped=true&"
import script from "./deduction-record.vue?vue&type=script&lang=js&"
export * from "./deduction-record.vue?vue&type=script&lang=js&"
import style0 from "./deduction-record.vue?vue&type=style&index=0&id=b4b3ab6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b3ab6e",
  null
  
)

export default component.exports